import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import { viewsKeys } from './queryKeyFactory';
import ServicesContext from '../../global/services/ServicesContext';
import { GearGridView } from '../../Model/GearGridView';

export function useGetViews(indexId?: number): UseQueryResult<GearGridView[], unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getIndexViews = () => {
    if (servicesCtx?.viewsService && indexId != null) {
      return servicesCtx.viewsService.getViews(indexId);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: viewsKeys.indexViews(indexId),
    queryFn: getIndexViews,
    retry: 0,
    enabled: indexId != null,
    staleTime: 1800000,
    gcTime: 1800000
  });
}
